module.exports = __webpack_public_path__ + "img/back_R.dab4d62a.png";